import type { GeneralDataAction, GeneralDataState } from '../types/generalData';
import type { PreviewAction, PreviewState } from '../types/preview';
import type { ToolbarAction, ToolbarState } from '../types/toolbar';
import type { UserAction, UserState } from '../types/user';
import { generalDataReducer } from './generalData';
import { previewReducer } from './preview';
import { toolbarReducer } from './toolbar';
import { userReducer } from './user';

export interface RootState {
    user: UserState;
    generalData: GeneralDataState;
    toolbar: ToolbarState;
    preview: PreviewState;
}

export type RootAction = UserAction | GeneralDataAction | ToolbarAction | PreviewAction;

const rootReducer = (state: RootState, action: RootAction): RootState => {
    return {
        user: userReducer(state.user, action as UserAction),
        generalData: generalDataReducer(state.generalData, action as GeneralDataAction),
        toolbar: toolbarReducer(state.toolbar, action as ToolbarAction),
        preview: previewReducer(state.preview, action as PreviewAction),
    };
};

export default rootReducer;
